import React, { useState } from 'react';

interface AdminLinksProps {
  operadoras: { id: string; nome: string; cor?: string }[];
  onBack: () => void;
}

const AdminLinks: React.FC<AdminLinksProps> = ({ operadoras, onBack }) => {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);
  
  // Obter o domínio base da aplicação
  const baseUrl = window.location.origin;
  
  // Função para copiar o link para a área de transferência
  const copyToClipboard = (text: string, index: number) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            Links Diretos para Operadoras
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Compartilhe estes links diretamente com as operadoras correspondentes.
          </p>
        </div>
        
        <div className="mt-8 space-y-4">
          {operadoras.map((operadora, index) => {
            const directLink = `${baseUrl}?operadora=${operadora.id}`;
            
            return (
              <div 
                key={operadora.id} 
                className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border rounded-lg"
                style={{ borderLeftWidth: '4px', borderLeftColor: operadora.cor }}
              >
                <div className="mb-2 sm:mb-0">
                  <h3 className="font-medium text-gray-900">{operadora.nome}</h3>
                  <p className="text-sm text-gray-500 break-all">{directLink}</p>
                </div>
                <button
                  onClick={() => copyToClipboard(directLink, index)}
                  className={`mt-2 sm:mt-0 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                    copiedIndex === index ? 'bg-green-600' : 'bg-primary hover:bg-primary-600'
                  }`}
                >
                  {copiedIndex === index ? 'Copiado!' : 'Copiar Link'}
                </button>
              </div>
            );
          })}
        </div>
        
        <div className="mt-8 flex justify-center">
          <button
            onClick={onBack}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLinks; 